import React, { useCallback, useMemo, useState } from 'react';

import { SelectOption } from '@shared/ui/Select/model/types';

interface IUseFilterSelectProps {
    needSearch: boolean;
    options: SelectOption[];
    setHighlightedIndex: React.Dispatch<React.SetStateAction<number | null>>;
}

export const useFilterSelect = ({
    needSearch,
    options,
    setHighlightedIndex,
}: IUseFilterSelectProps) => {
    const [filter, setFilter] = useState('');

    const filteredOptions = useMemo(() => {
        if (needSearch && filter) {
            return options?.filter((option) =>
                option.label.toLowerCase().includes(filter.toLowerCase())
            );
        }
        return options;
    }, [options, filter, needSearch]);

    const handleFilterChange = useCallback(
        (_: string, value: string) => {
            setFilter(value);
            setHighlightedIndex(0);
        },
        [setHighlightedIndex]
    );

    return { filteredOptions, handleFilterChange, filter, setFilter };
};
